import { ModalSelectDate } from "./modalSelectDate.js";
import { ModalShowAbsenceDetails } from "./modalShowAbsenceDetails.js";
import { ModalTiteledWindow } from "./modalWindow.js";
import { RadioButtons } from "../radiobuttons.js";
import { groupData } from "../util.js";
import { sortObjectArray } from "../util.js";

export class ModalShowAbsences extends ModalTiteledWindow {

   constructor(app, absenceType, selector=false) {
      super();
      this.app = app;
      this.absenceType = absenceType;
      this.selector = selector
      this.addClass('modal-show-absences');
      this.setTitle(`MSS-Fehlstunden`);

      this.setBody(`
         <div class="select"><span class="help icon-info" selector=".mss-absences" style="position: absolute; right: 0.5rem;"></span>
            <span>
               <span class="print icon-print" style="font-size: 1.2rem" onclick="window.print()"></span>
               <span class="save icon-download" style="font-size: 1.2rem"></span>
            </span>
            <div class="years"></div>
            <div class="date-range">
               <div class="range">
                  von 
                  <div class="date date-from" date="from"></div>
                  bis
                  <div class="date date-to" date="to"></div>
               </div>
            </div>

         </div>
         <div class="absences"></div>
      `);

      if (this.selector) {
         this.panel.querySelector('.select .years').style.display = 'none';
      }

      this.dateRange = new RadioButtons('date-range', {
            onSelect: (value) => this.setRangeType(value)
         },
         [
            { label: "Schuljahr", value: "full-year" },
            { label: "Zeitraum",  value: "date-range" },
         ]
      );
      this.panel.querySelector('.select .date-range').prepend(this.dateRange.getElement());

      const mssClasses = Object.values(this.app.dm.getCurrentYear().classes)
         .filter(cls => cls.year >= 11 && cls.year <= 13)
         .map(cls => { return { label: cls.name, value: cls.id }; });

      this.mssClass = new RadioButtons('mss-class', { onSelect: (value) => this.loadAbsences(), minWidth: '4rem' }, mssClasses);

      this.panel.querySelector('.select .years').append(this.mssClass.getElement());


      this.panel.querySelectorAll('.years .year').forEach(el => {
         el.onclick = (event) => {
            this.loadAbsences(parseInt(event.currentTarget.dataset.year));
            this.panel.querySelectorAll('.years .year').forEach(el => el.classList.remove('selected'));
            el.classList.add('selected');
         }
      });

      this.elDateFrom = this.panel.querySelector('.date-range .date-from');
      this.elDateTo = this.panel.querySelector('.date-range .date-to');

         [this.elDateFrom, this.elDateTo].forEach(el => el.onclick = (event) => {
            const elDate = event.currentTarget;
            new ModalSelectDate({ onSelect: (value) => {
               elDate.dataset.date = value.isoDate();
               elDate.innerText = value.toGermanDate();
               localStorage.setItem('mssAbsenceDatesRange', JSON.stringify({ from: this.elDateFrom.dataset.date, to: this.elDateTo.dataset.date }));
               this.loadAbsences();
            }});
         });

      this.dateRange.setValue('full-year', true);
      
      this.panel.querySelector('.save').onclick = (event) => {
         this.downloadPupilData();
      }

      this.collectingSortKeys = false;
      this.sortKeys = ['<.normedLastName', '<.normedFirstName'];
      this.setupHelp(this.app);

      setTimeout(() => this.show(), 1);

   }

   /**
    * Erstellt eine CSV-Datei, die die Anzahl der unentschuldigten Fehlstunden der betreffenden SuS und weitere Daten enthält.
    */
   async downloadPupilData() {

      if (!this.absences) return;

      console.log(this.absences);

      const pupilMap = {};

      for (let abs of this.absences) {
         if (!abs.justified) {
            if (!(abs.pupilId in pupilMap)) {
               pupilMap[abs.pupilId] = { pupil: this.app.dm.getUser(abs.pupilId), cnt: 0, subjects: {} }
            }
            pupilMap[abs.pupilId].cnt += abs.cnt;
            pupilMap[abs.pupilId].subjects[abs.course] = true;
         }
      }

      const data = [];
      for (const item of Object.values(pupilMap)) {
         if (item.pupil.id === 0) continue;
         const tutor = this.app.dm.getUser(item.pupil.tutorId);
         data.push({
            className: this.app.dm.getClassName(item.pupil.classId),
            tutor: (tutor.gender ==='M' ? "Herr " : "Frau ") + tutor.lastName,
            firstName: item.pupil.firstName,
            lastName: item.pupil.lastName,
            gender: item.pupil.gender.toLowerCase(),
            subjects: Object.keys(item.subjects).join(', '),
            cnt: item.cnt
         });
      }

      const schema = [
         { column: "Jahrgang", type: String, value: o => o.className },
         { column: "Stammkurs", type: String, value: o => o.tutor },
         { column: "Kindvorname", type: String, value: o => o.firstName },
         { column: "Elternname", type: String, value: o => o.lastName},
         { column: "Kindsgeschlecht", type: String, value: o => o.gender},
         { column: "Straße", type: String, value: o => '', width: 40 },
         { column: "Wohnort", type: String, value: o => '', width: 30 },
         { column: "Fehlstundenanzahl", type: Number, value: o => o.cnt },
         { column: "Fächer", type: String, value: o => o.subjects }
      ];

      await writeXlsxFile(data, {
         schema,
         fileName: `Fehlstunden unentschuldigt.xlsx`
      });

   }

   setRangeType(type) {

      this.sortKeys = ['<.normedLastName', '<.normedFirstName'];

      if (type === 'full-year') {
         this.panel.querySelector('.date-range .range').style.display = 'none';
         this.loadAbsences();
      }
      else {

         let range;
         try {
            range = JSON.parse(localStorage.getItem('mssAbsenceDatesRange'));
            if (!range) throw new Error();
         }
         catch(e)  { range = { from: (new Date()).isoDate(), to: (new Date()).isoDate() }; }

         this.panel.querySelector('.date-range .range').style.display = 'flex';

         this.elDateFrom.dataset.date = range.from;
         this.elDateFrom.innerText = Date.fromString(range.from).toGermanDate();
         this.elDateTo.dataset.date = range.to;
         this.elDateTo.innerText = Date.fromString(range.to).toGermanDate();

         this.loadAbsences();

      }

   }

   async loadAbsences() {

      this.loadOptions = {
         action: 'classreg-absence-get',
         type: this.absenceType
      };

      if (this.selector) {
         if ('course' in this.selector) {
            this.loadOptions.courseId = this.selector.course.id;
         }
         else if ('tutPupilIds' in this.selector) {
            this.loadOptions.tutPupilIds = this.selector.tutPupilIds;
         }
         else {
            throw "Ungültiger Selektor";
         }
      }
      else {
         this.classId = this.mssClass.getValue();
         if (this.classId === false) return;
         this.loadOptions.classIds = [this.classId];
      }

      if (this.dateRange.getValue() !== 'full-year') {
         this.loadOptions.dateFrom = this.elDateFrom.dataset.date;
         this.loadOptions.dateTo = this.elDateTo.dataset.date;
      }

      const response = await this.app.dm.sinRequest(this.loadOptions);
      this.absences = response.data;

      if (this.dateRange.getValue() === 'full-year') {
         let html = `<table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr><th></th><th></th><th colspan="3" class="bl-2">1. HJ</th><th colspan="3" class="bl-2">2. HJ</th><th colspan="3" class="bl-2 br-2">gesamt</th></tr>
            <tr>
               <th class="ta-left" data-sort-key="<.normedLastName">Nachname</th>
               <th class="ta-left" data-sort-key="<.normedFirstName">Vorname</th>
               <th class="bl-2" data-sort-key=">.absences.j1">✔</th>
               <th data-sort-key=">.absences.n1">✖</th>
               <th class="sum" data-sort-key=">.absences.sum1">∑</th>
               <th class="bl-2" data-sort-key=">.absences.j2">✔</th>
               <th data-sort-key=">.absences.n2">✖</th>
               <th class="sum" data-sort-key=">.absences.sum2">∑</th>
               <th class="bl-2" data-sort-key=">.absences.js">✔</th>
               <th data-sort-key=">.absences.ns">✖</th>
               <th class="sum br-2" data-sort-key=">.absences.sum">∑</th>
            </tr>
         </thead>
         <tbody></tbody></table>`;
         this.panel.querySelector('.absences').innerHTML = html;
      }
      else {
         let html = `<table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr>
               <th class="ta-left" data-sort-key="<.normedLastName">Nachname</th>
               <th class="ta-left" data-sort-key="<.normedFirstName">Vorname</th>
               <th class="bl-2" data-sort-key=">.absences.j">✔</th>
               <th data-sort-key=">.absences.n">✖</th>
               <th class="sum br-2" data-sort-key=">.absences.stats.sum">∑</th>
            </tr>
         </thead>
         <tbody></tbody></table>`;
         this.panel.querySelector('.absences').innerHTML = html;   
      }

      this.panel.querySelectorAll('th').forEach(elTh => {
         const indexColor = [ .5, .3, .2 ];
         for (let i=0; i<this.sortKeys.length; ++i) {
            if (elTh.dataset.sortKey === this.sortKeys[i]) {
               elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[i]})`;
            }
         }
      });

      this.panel.querySelectorAll('.absences th').forEach(elTh => {
         let sortKey = elTh.dataset.sortKey;
         if (sortKey) elTh.onclick = () => this.collectSortKey(elTh, sortKey);
      });

      this.updateAbsences();
      return this.absences;

   }

   updateAbsences() {

      if (!this.sortKeys.includes('<.normedLastName')) this.sortKeys.push('<.normedLastName');

      if (this.dateRange.getValue() !== 'full-year') {
         let data = groupData(this.absences, ['pupilId'],
            (group) => { group.j = 0; group.n = 0; group.sum = 0; },
            (group, item) => {
               if (item.justified) group.j += item.cnt;
               else                group.n += item.cnt;
               group.sum += item.cnt;
            }
         );
         this.pupils = this.applyAbsencesToPupils(data, { j: 0, n: 0, sum: 0 });

         sortObjectArray(this.pupils, this.sortKeys);

         let  html = '';
         for (let pupil of this.pupils) {
            const abs = pupil.absences;
            html += `<tr data-pupil-id="${pupil.id}"><td>${pupil.lastName}</td><td>${pupil.firstName}</td>
            <td class="number bl-2">${abs.j}</td><td class="number">${abs.n}</td><td class="number sum br-2">${abs.sum}</td></tr>`;
         }

         this.panel.querySelector('.absences tbody').innerHTML = html;

      }
      else {
         const year = this.app.dm.getCurrentYear();

         let data = groupData(this.absences, ['pupilId'],
            (group) => {
               group.j1 = 0; group.n1 = 0, group.sum1 = 0,
               group.j2 = 0; group.n2 = 0, group.sum2 = 0,
               group.js = 0; group.ns = 0, group.sum = 0
            },
            (group, item) => {
               if (item.date >= year.dateFrom && item.date < year.dateHj2) {
                  if (item.justified) group.j1 += item.cnt, group.js += item.cnt;
                  else                group.n1 += item.cnt, group.ns += item.cnt; 
                  group.sum1 += item.cnt;
               }
               else if (item.date >= year.dateHj2  && item.date < year.dateTo) {
                  if (item.justified) group.j2 += item.cnt, group.js += item.cnt;
                  else                group.n2 += item.cnt, group.ns += item.cnt; 
                  group.sum2 += item.cnt;
               }
               group.sum += item.cnt;
            }
         );

         this.pupils = this.applyAbsencesToPupils(data, {
            j1: 0, n1: 0, sum1: 0, j2: 0, n2: 0, sum2: 0, js: 0, ns: 0, sum: 0 }
         );

         sortObjectArray(this.pupils, this.sortKeys);

         let  html = '';
         for (let pupil of this.pupils) {
            const abs = pupil.absences;

            html += `<tr data-pupil-id="${pupil.id}"><td>${pupil.lastName}</td><td>${pupil.firstName}</td>
               <td class="number bl-2">${abs.j1}</td><td class="number">${abs.n1}</td><td class="number sum br-2">${abs.sum1}</td>
               <td class="number bl-2">${abs.j2}</td><td class="number">${abs.n2}</td><td class="number sum br-2">${abs.sum2}</td>
               <td class="number bl-2">${abs.js}</td><td class="number">${abs.ns}</td><td class="number sum br-2">${abs.sum}</td></tr>`;

         }

         this.panel.querySelector('.absences tbody').innerHTML = html;

      }

      this.panel.querySelectorAll('.absences tbody tr td').forEach(elTd => {
         elTd.onclick = () => {
            const pupilId = parseInt(elTd.parentElement.dataset.pupilId);
            new ModalShowAbsenceDetails(this.app, pupilId, this.absences.filter(abs => abs.pupilId === pupilId), this);
         }
      });

   }

   applyAbsencesToPupils(absences, def) {

      if (this.selector) {
         if ('course' in this.selector) {
            let pupils = this.selector.course.pupils.map(pupilId => {
               let pupil = this.app.dm.getUser(pupilId);
               const abs = absences.find(item => item.pupilId === pupil.id);
               if (abs) pupil.absences = abs;
               else pupil.absences = Object.assign({}, def);
               return pupil;
            });      
            return pupils;
         }
         else if ('tutPupilIds' in this.selector) {
            return this.selector.tutPupilIds.map(pupilId => {
               let pupil = this.app.dm.getUser(pupilId);
               const abs = absences.find(item => item.pupilId === pupil.id);
               if (abs) pupil.absences = abs;
               else pupil.absences = Object.assign({}, def);
               return pupil;
            });
         }
      }
      else {
         let cls = this.app.dm.getClass(this.classId);
         let pupils = cls.pupils.map(pupilId => {
            let pupil = this.app.dm.getUser(pupilId);
            const abs = absences.find(item => item.pupilId === pupil.id);
            if (abs) pupil.absences = abs;
            else pupil.absences = Object.assign({}, def);
            return pupil;
         });      
         return pupils;
      }

   }

   collectSortKey(elTh, sortKey) {

      const indexColor = [ .5, .3, .2 ];

      if (!this.collectingSortKeys) {
         this.sortKeys = [ sortKey ];
         this.collectingSortKeys = true;
         setTimeout(() => {
            this.collectingSortKeys = false;
            this.updateAbsences();
         }, 1500);
         this.panel.querySelectorAll('th').forEach(elTh => elTh.style.removeProperty('background-color'));
         elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[0]})`;
      }
      else {
         if (!this.sortKeys.includes(sortKey) && this.sortKeys.length < 3) {
            this.sortKeys.push(sortKey);
            elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[this.sortKeys.length-1]})`;
         }
      }

   }

}
